import * as symbols from "../../symbols";

export default function () {
    Number.prototype[symbols.isEmpty] = function () {
        return this.length === 0;
    };
}